import { useContext } from 'react'
import { ThemeContext } from './ThemeProvider'

/** Access the active theme preference and resolved scheme. */
export function useTheme() {
  const ctx = useContext(ThemeContext)
  if (!ctx) throw new Error('useTheme must be used within <ThemeProvider>')
  return ctx
}
